export const PRICING = {
  dropin: {
    label: 'Drop-in',
    price: 25,
    // 30
    note: 'All drop-in classes',
    detail: "Drop-in for any class on the schedule, a single class with no commitment. Perfect for trying something new.",
    floriumParam: 'dropin',
  },
  pass4: {
    label: '4-class pass',
    price: 84,
    // 92
    note: '$23 per class · 8-week expiry',
    detail: 'A great way to build a regular practice without a monthly commitment.',
    floriumParam: 'pass4',
  },
  pass8: {
    label: '8-class pass',
    price: 152,
    // 172
    note: '$21 per class · 3-month expiry',
    detail: 'The best value class pack. Attend at your own pace over three months.',
    floriumParam: 'pass8',
  },
  committed: {
    label: 'Committed',
    price: 129,
    // 145
    period: 'month',
    note: 'Twice-weekly membership',
    perClassNote: '$18 per class',
    detail: 'Our most popular option. Two classes a week, every week — the sweet spot for building a consistent practice and seeing real results.',
    featured: true,
    badge: 'Most popular',
    floriumParam: 'member2x',
  },
  monthly: {
    label: 'Monthly',
    price: 169,
    // 189
    period: 'month',
    note: 'Monthly membership',
    detail: 'Practice one class per day. Ideal for dedicated students who want full access to everything we offer.',
    floriumParam: 'memberUnl',
  },
};